import { z } from 'zod/v3';
import {
  ActionResult,
  ApplicableContext,
  BaseAction,
  ExecuteContext,
} from '@cotera/client/v0/actions/framework';
import { ok } from 'neverthrow';
import { ArtifactPanelModel } from '../artifact-panel.model';

const inputSchema = z.object({});

export class CollapseArtifactPanelAction extends BaseAction<
  z.infer<typeof inputSchema>,
  { t: string; message?: string }[]
> {
  title = 'Collapse Artifact Panel';
  inputSchema = inputSchema;
  group = 'View';
  description = 'Restore the split view with chat beside the artifact';
  icon = 'collapse';

  applicable(context: ApplicableContext): boolean {
    const model = context.getInScopeModelOfType(ArtifactPanelModel);
    if (model === null) {
      return false;
    }
    return model.isExpandedWatchable.snapshot();
  }

  async execute(
    _params: z.infer<typeof inputSchema>,
    context: ExecuteContext
  ): Promise<ActionResult<{ t: string; message?: string }[]>> {
    context.getInScopeModelOfType(ArtifactPanelModel)?.collapse();
    return ok({});
  }
}
